import { Typography } from '@mui/material';
import { useDashboardCardTitleStyles } from './dashboard-card-title.styles';

export function DashboardCardTitle({ color, title }: { title: string; color?: string }) {
  const classes = useDashboardCardTitleStyles({ color });
  return <Typography className={classes.title}>{title}</Typography>;
}
